import { Warning } from '@phosphor-icons/react';
import { ProgressBar } from '@reelplicate/ui';
import { type ReactNode, useId } from 'react';

/**
 * Figma "Usage Meter" (104:173): used / limit against a plan quota. At the
 * limit it turns danger and says what stopped, with a way out (`action`).
 */
export function UsageMeter({
  label,
  used,
  limit,
  caption,
  action,
}: {
  label: string;
  used: number;
  limit: number;
  caption: ReactNode;
  /** Shown after the caption at the limit, e.g. an "Upgrade" link. */
  action?: ReactNode;
}) {
  const id = useId();
  const full = used >= limit;
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-2">
      <div className="flex items-baseline">
        <p id={id} className="text-label-md text-text-primary flex-1">
          {label}
        </p>
        <p className="text-data-md text-text-primary">
          {used}
          <span className="text-caption text-text-tertiary"> / {limit}</span>
        </p>
      </div>
      <ProgressBar
        value={Math.min(used, limit)}
        max={limit}
        tone={full ? 'danger' : 'brand'}
        aria-labelledby={id}
      />
      {full ? (
        <div className="flex items-center gap-1.5">
          <Warning aria-hidden className="text-status-danger-fg size-3.5 shrink-0" />
          <p className="text-caption text-status-danger-fg flex-1">{caption}</p>
          {action}
        </div>
      ) : (
        <p className="text-caption text-text-tertiary">{caption}</p>
      )}
    </div>
  );
}
